import {RootStore} from '../../stores/RootStore';

export const getSlugFromPlatform = (rootStore: RootStore): string | null => {
  const {path, prefix} = rootStore.controllerParams.controllerConfig.wixCodeApi.location;
  if (rootStore.controllerParams.$widget.props.slug) {
    return rootStore.controllerParams.$widget.props.slug;
  }

  // TODO:Zeev: make this pretty
  if (rootStore.controllerParams.flowAPI.environment.isViewer || prefix !== undefined) {
    if (path.length) {
      return path[path.length - 1];
    }
  } else {
    if (path.length > 1 && path[path.length - 1] !== 'product-page-static') {
      return path[path.length - 1];
    }
  }

  return null;
};
